// import Evaluation360 from './Evaluation360';

export default {
  // component: Evaluation360,
  priority: 750,
  permissions: ['360EvaluationMenu/', 'dce35a0cdce35a0cb769c36d0ddb19c6b495bc6d83ac7daceb8e7af63d97e33e94fb3609b769c36d0ddb19c6b495bc6d83ac7daceb8e7af63d97e33e94fb3609'] , //['QuestionGroupMenu','QuestionnaireMenu', 'QuestionAssignMenu', 'ContactsMenu', '360PatternMenu', 'PeriodMenu', 'EvaluateMenu', 'EvaluationReportMenu'],
  name: app.translate('routes.home.evaluation-360.Evaluation360'),
  icon: 'crop-rotate',
  drawer: true,
  notShow:true
};


